import React from 'react';
import {QUESTIONIDS, SliderQuestion} from '../types/question';
import useQuestionStore from '../store/navigation';
import CircleSlider from '../components/CircleSlider';
import {useResultStore} from '../store/responses';
import useMediaQuery from '../hooks/useMediaQuery';
import QuestionContentWrapper from '../components/QuestionContentWrapper';
import Div from '../components/Div.styled';
import {sendAnalyticPayload} from '../utils/analytic';
import {QuestionData} from '../constants/questions';

function QuestionFourPassenger(props: SliderQuestion) {
  const {nextStepId, title, min, max} = props;
  const {setCurrentQuestion, currentQuestion} = useQuestionStore();
  const {updateQuestion, result} = useResultStore();
  const resultData = (result[currentQuestion] as number) || 1;
  const {isMobile} = useMediaQuery();
  const [value, setValue] = React.useState(() => {
    if (resultData) {
      return resultData;
    }
    return 0;
  });
  function onChange(value: number) {
    setValue(value);
  }

  function onClickNext() {
    setCurrentQuestion(nextStepId);
    updateQuestion({
      id: currentQuestion as typeof QUESTIONIDS.questionFourPassengers,
      value: value,
    });
    sendAnalyticPayload({
      process: {
        StepName: currentQuestion,
        StepNumber:
          QuestionData[currentQuestion]?.progressValue.toString() ?? '',
      },
      question: [
        {
          Question: currentQuestion,
          Answer: [
            {
              value: value.toString(),
              type: 'slider',
            },
          ],
        },
      ],
    });
  }

  return (
    <QuestionContentWrapper title={title} handleClick={onClickNext}>
      <Div padding="20px 0">
        <CircleSlider
          min={min}
          max={max}
          initialValue={resultData}
          onChange={onChange}
          width={isMobile ? 200 : 250}
        />
      </Div>
    </QuestionContentWrapper>
  );
}

export default QuestionFourPassenger;
